module.exports = __webpack_public_path__ + "img/Padres.9fea25b8.png";